/**
 * Auth Configuration - Scope Helpers
 * Provides login and token request configurations for MSAL
 */

import { getApiAppUri } from './bootstrap'

/**
 * Get scopes for login request - basic user profile information plus API access
 */
export function getLoginRequest() {
  const apiAppUri = getApiAppUri()
  return {
    scopes: ['openid', 'profile', 'email', `${apiAppUri}/Api.Access`],
  }
}

/**
 * Get scopes for API token requests
 */
export function getTokenRequest() {
  const apiAppUri = getApiAppUri()
  return {
    scopes: [`${apiAppUri}/Api.Access`],
  }
}
